import { t } from 'ttag';

export const REQUEST_MESSAGES = {
  /* fetch */

  fetch_general_error: () => t`Error occured while getting data`,

  fetch_companies_error: () => t`Unable to fetch companies`,
  fetch_stats_error: () => t`Unable to fetch stats`,
  settings_saved: () => t`Settings saved successfully`,
  settings_saved_error: () => t`Unable to save settings`,
  sort_course_error: () => t`Unable to sort course`,

  fetch_users_error: () => t`Unable to fetch users`,
  fetch_roles_error: () => t`Unable to fetch roles`,
  fetch_activities_error: () => t`Unable to fetch activities`,

  fetch_templates_error: () => t`Unable to order sections`,

  fetch_step_complete_error: () => t`You need to complete the flash cards with correct feedback`,

  fetch_form_error: () => t`Unable to fetch Forms`,

  fetch_clients_error: () => t`Unable to fetch Clients`,

  fetch_glossaries_error: () => t`Unable to fetch Glossaries`,

  fetch_stat_error: () => t`Error occured while getting Data Collection`,
  fetch_proposal_template_error: () => t`Unable to fetch proposal templates`,
  create_course_section: () => t`Unable to create section`,
  update_course_section_step: () => t`Unable to update step`,

  delete_course_section_step: () => t`Unable to delete step`,
  update_checklist_steps_sort: () => t`Unable to order steps`,

  create_course_section_step: () => t`Unable to create step`,

  update_checklist_section_sort: () => t`Unable to order sections`,

  update_course_section: () => t`Unable to update section`,

  delete_course_section: () => t`Unable to delete section`,

  fetch_ideas_error: () => t`Unable to fetch ideas`,

  /* mutation - checklist Section Steps*/

  create_client: () => ({
    success: t`Client created successfully`,
    error: t`Unable to create client`,
  }),

  client_template_transfer: () => ({
    success: t`Content transferred successfully`,
    error: t`Unable to transferred content successfully`,
  }),

  delete_client: () => ({
    success: t`Account canceled successfully`,
    error: t`Unable to cancel account`,
  }),

  settings_updated: () => ({
    success: t`Settings updated successfully`,
    error: t`Unable to update settings`,
  }),

  fetch_org_board_error: () => t`Error occured while getting Organization Board`,

  create_org_board: () => ({
    success: t`Chart created successfully`,
    error: t`Unable to create chart`,
  }),

  update_org_board: () => ({
    success: t`Chart updated successfully`,
    error: t`Unable to update Chart`,
  }),

  delete_org_board: () => ({
    success: t`Org Board deleted successfully`,
    error: t`Unable to delete Org Board`,
  }),

  delete_org_board_position: () => ({
    success: t`Position deleted successfully`,
    error: t`Unable to delete Position`,
  }),

  create_task: () => ({
    success: t`Task created successfully`,
    error: t`Unable to create task`,
  }),

  fetch_order_error: () => t`Error occured while getting order`,
  create_order: () => ({
    success: t`Order created successfully`,
    error: t`Unable to create order`,
  }),
  update_order: () => ({
    success: t`Order updated successfully`,
    error: t`Unable to update Order`,
  }),
  delete_order: () => ({
    success: t`Order deleted successfully`,
    error: t`Unable to delete Order`,
  }),
  create_company: () => ({
    success: t`Company created successfully`,
    error: t`Unable to create company`,
  }),
  update_company: () => ({
    success: t`Company updated successfully`,
    error: t`Unable to update company`,
  }),
  delete_company: () => ({
    success: t`Company deleted successfully`,
    error: t`Unable to delete company`,
  }),

  fetch_category_error: () => t`Error occured while getting category`,
  create_category: () => ({
    success: t`Category created successfully`,
    error: t`Unable to create category`,
  }),
  update_category: () => ({
    success: t`Category updated successfully`,
    error: t`Unable to update category`,
  }),
  delete_category: () => ({
    success: t`Category deleted successfully`,
    error: t`Unable to delete category`,
  }),
  /* mutation - user */
  create_user: () => ({
    success: t`User created successfully`,
    error: t`Unable to create user`,
  }),

  update_user: () => ({
    success: t`User updated successfully`,
    error: t`Unable to update user`,
  }),

  delete_user: () => ({
    success: t`User deleted successfully`,
    error: t`Unable to delete user`,
  }),

  /* mutation - Glossaries*/
  create_glossary: () => ({
    success: t`Glossary created successfully`,
    error: t`Unable to create glossary`,
  }),

  update_glossary: () => ({
    success: t`Glossary updated successfully`,
    error: t`Unable to update glossary`,
  }),

  delete_glossary: () => ({
    success: t`Glossary deleted successfully`,
    error: t`Unable to delete glossary`,
  }),

  re_preview_glossary: () => ({
    success: t`Definition words unlinked`,
    error: t`Unable to unlink the definition words`,
  }),

  fetch_adminscale_error: () => t`Error occured while getting Admin Scale`,
  fetch_adminscale_policy_error: () => t`Error occured while getting Policy`,
  fetch_adminscale_statistics_error: () => t`Error occured while getting Statistics`,
  create_adminscale: () => ({
    success: t`Admin Scale created successfully`,
    error: t`Unable to create Admin Scale`,
  }),
  update_adminscale: () => ({
    success: t`Admin Scale updated successfully`,
    error: t`Unable to update Admin Scale`,
  }),
  delete_adminscale: () => ({
    success: t`Admin Scale deleted successfully`,
    error: t`Unable to delete Admin Scale`,
  }),

  fetch_adminscale_child_error: () => t`Error occured while getting Admin Scale`,
  create_adminscale_child: () => ({
    success: t`Admin Scale Child created successfully`,
    error: t`Unable to create Admin Scale Child`,
  }),
  update_adminscale_child: () => ({
    success: t`Admin Scale Child updated successfully`,
    error: t`Unable to update Admin Scale Child`,
  }),
  delete_adminscale_child: () => ({
    success: t`Admin Scale Child deleted successfully`,
    error: t`Unable to delete Admin Scale Child`,
  }),
  update_adminscale_sorted: () => ({
    success: t`Sorted successfully`,
    error: t`Unable to Sorted Admin Scale Child`,
  }),

  fetch_companypolicy_error: () => t`Error occured while getting Company Policy`,
  create_companypolicy: () => ({
    success: t`Company Policy created successfully`,
    error: t`Unable to create CompanyPolicy`,
  }),
  update_companypolicy: () => ({
    success: t`Company Policy updated successfully`,
    error: t`Unable to update Company Policy`,
  }),
  delete_companypolicy: () => ({
    success: t`Company Policy deleted successfully`,
    error: t`Unable to delete Company Policy`,
  }),

  fetch_programs_error: () => t`Error occured while getting Programs`,
  create_programs: () => ({
    success: t`Program created successfully`,
    error: t`Unable to create Program`,
  }),
  update_programs: () => ({
    success: t`Program updated successfully`,
    error: t`Unable to update Program`,
  }),
  archive_programs: () => ({
    success: t`Program archived successfully`,
    error: t`Unable to archive Program`,
  }),
  delete_programs: () => ({
    success: t`Program deleted successfully`,
    error: t`Unable to delete Program`,
  }),

  fetch_program_sections_error: () => t`Error occured while getting Sections`,
  create_program_sections: () => ({
    success: t`Section created successfully`,
    error: t`Unable to create Section`,
  }),
  update_program_section: () => ({
    success: t`Section updated successfully`,
    error: t`Unable to update Section`,
  }),
  delete_program_section: () => ({
    success: t`Section deleted successfully`,
    error: t`Unable to delete Section`,
  }),

  fetch_program_target_error: () => t`Error occured while getting Targets`,
  create_program_target: () => ({
    success: t`Target created successfully`,
    error: t`Unable to create Target`,
  }),
  update_program_target: () => ({
    success: t`Target updated successfully`,
    error: t`Unable to update Target`,
  }),
  delete_program_target: () => ({
    success: t`Target deleted successfully`,
    error: t`Unable to delete Target`,
  }),
  update_assignee_steps: () => ({
    success: t`Assignee updated successfully`,
    error: t`Unable to assign assignee`,
  }),

  fetch_comments_error: () => t`Error occured while getting Comments`,
  create_comment: () => ({
    success: t`Comment created successfully`,
    error: t`Unable to create Comment`,
  }),
  update_comment: () => ({
    success: t`Comment updated successfully`,
    error: t`Unable to update Comment`,
  }),
  delete_comment: () => ({
    success: t`Comment deleted successfully`,
    error: t`Unable to delete Comment`,
  }),

  create_comment_file: () => ({
    success: t`File uploaded successfully`,
    error: t`Unable to upload File`,
  }),

  complete_program_target_nudge: () => ({
    success: t`Nudge sent successfully`,
    error: t`Unable to send nudge`,
  }),

  complete_program_target: () => ({
    success: t`Target completed successfully`,
    error: t`Unable to complete Target`,
  }),

  approve_program_target_report: () => ({
    success: t`Report approved successfully`,
    error: t`Unable to approve Report`,
  }),

  reject_program_target_report: () => ({
    success: t`Report rejected successfully`,
    error: t`Unable to reject Report`,
  }),

  fetch_battle_plan_task_error: () => t`Error occured while getting Tasks`,

  create_battle_plan_task: () => ({
    success: t`Target added successfully`,
    error: t`Unable to add Task`,
  }),

  update_battle_plan_task: () => ({
    success: t`Task updated successfully`,
    error: t`Unable to update Task`,
  }),

  delete_battle_plan_task: () => ({
    success: t`Task deleted successfully`,
    error: t`Unable to delete Task`,
  }),

  complete_battle_plan_task: () => ({
    success: t`Task updated successfully`,
    error: t`Unable to update Task status`,
  }),

  fetch_battle_plan_section_error: () => t`Error occured while getting Tasks`,

  create_battle_plan_section: () => ({
    success: t`Task created successfully`,
    error: t`Unable to create Task`,
  }),

  update_battle_plan_section: () => ({
    success: t`Section updated successfully`,
    error: t`Unable to update Section`,
  }),

  delete_battle_plan_section: () => ({
    success: t`Section deleted successfully`,
    error: t`Unable to delete Section`,
  }),

  fetch_groups_error: () => t`Error occured while getting Groups`,
  create_group: () => ({
    success: t`Group created successfully`,
    error: t`Unable to create Group`,
  }),
  update_group: () => ({
    success: t`Group updated successfully`,
    error: t`Unable to update Group`,
  }),
  delete_group: () => ({
    success: t`Group deleted successfully`,
    error: t`Unable to delete Group`,
  }),

  fetch_graph_error: () => t`Error occured while getting Graphs`,

  fetch_graph_pdf_error: () => t`Error occured while generating Graphs pdf`,

  create_graph: () => ({
    success: t`Graph created successfully`,
    error: t`Unable to create Graph`,
  }),

  graph_sort: () => ({
    success: t`Graphs sorted successfully`,
    error: t`Unable to sort Graphs`,
  }),

  update_graph: () => ({
    success: t`Graph updated successfully`,
    error: t`Unable to update Graph`,
  }),

  delete_graph: () => ({
    success: t`Graph deleted successfully`,
    error: t`Unable to delete Graph`,
  }),

  fetch_graph_value_error: () => t`Error occured while getting Graph Values`,

  create_graph_value: () => ({
    success: t`Value created successfully`,
    error: t`Unable to create Value`,
  }),

  update_graph_value: () => ({
    success: t`Value updated successfully`,
    error: t`Unable to update Value`,
  }),

  delete_graph_value: () => ({
    success: t`Value deleted successfully`,
    error: t`Unable to delete Value`,
  }),

  fetch_graph_note_error: () => t`Error occured while getting Notes`,

  create_graph_note: () => ({
    success: t`Note created successfully`,
    error: t`Unable to create Note`,
  }),

  update_graph_note: () => ({
    success: t`Note updated successfully`,
    error: t`Unable to update Note`,
  }),

  delete_graph_note: () => ({
    success: t`Note deleted successfully`,
    error: t`Unable to delete Note`,
  }),

  fetch_graph_group_error: () => t`Error occured while getting Groups`,

  create_graph_group: () => ({
    success: t`Group created successfully`,
    error: t`Unable to create Group`,
  }),

  update_graph_group: () => ({
    success: t`Group updated successfully`,
    error: t`Unable to update Group`,
  }),

  delete_graph_group: () => ({
    success: t`Group deleted successfully`,
    error: t`Unable to delete Group`,
  }),

  fetch_summary_error: () => t`Error occured while fetching Graphs`,

  create_summary_error: () => ({
    success: t`Graphs updated successfully!`,
    error: t`Graphs could not be updated`,
  }),

  // Graph Condition Response
  fetch_condition_graph_group_error: () => t`Error occured while getting Graph Conditions`,

  create_condition_graph: () => ({
    success: t`Condition submitted successfully`,
    error: t`Unable to create Condition`,
  }),

  update_condition_graph: () => ({
    success: t`Condition submitted successfully`,
    error: t`Unable to update Condition`,
  }),

  delete_condition_graph: () => ({
    success: t`Graph Condition deleted successfully`,
    error: t`Unable to delete Graph Condition`,
  }),

  create_condition_graph_task_sort: () => ({
    success: t`Tasks sorted successfully`,
    error: t`Unable to sort Tasks`,
  }),

  fetch_permissions_error: () => t`Error occured while getting permissions`,
  assign_permissions: () => t`Error occured while trying to assign permissions`,

  fetch_group_users_error: () => t`Error occured while getting Group Users`,
  create_group_user: () => ({
    success: t`Group User created successfully`,
    error: t`Unable to create Group User`,
  }),
  update_group_user: () => ({
    success: t`Group User updated successfully`,
    error: t`Unable to update Group User`,
  }),
  update_permission_error: () => ({
    success: t`Permission updated successfully`,
    error: t`Unable to update permissions`,
  }),
  delete_group_user: () => ({
    success: t`Group User deleted successfully`,
    error: t`Unable to delete Group User`,
  }),

  create_task_status: () => ({
    success: t`Task Status created successfully`,
    error: t`Unable to create task status`,
  }),

  update_task_status: () => ({
    success: t`Task Status updated successfully`,
    error: t`Unable to update task status`,
  }),

  delete_task_status: () => ({
    success: t`Task Status deleted successfully`,
    error: t`Unable to delete task status`,
  }),

  delete_task_target_type: () => ({
    success: t`Target Type deleted successfully`,
    error: t`Unable to delete target type`,
  }),

  fill_form: () => ({
    success: t`Form saved successfully`,
    error: t`Unable to update form`,
  }),

  /* mutation - Form*/
  create_form: () => ({
    success: t`Form created successfully`,
    error: t`Unable to create form`,
  }),

  update_form: () => ({
    success: t`Form updated successfully`,
    error: t`Unable to update form`,
  }),

  delete_form: () => ({
    success: t`Form deleted successfully`,
    error: t`Unable to delete form`,
  }),

  clone_form: () => ({
    success: t`Form cloned successfully`,
    error: t`Unable to clone form`,
  }),

  save_form_fields: () => ({
    success: t`Form Fields saved successfully`,
    error: t`Unable to save form fields`,
  }),

  /* mutation - Stat*/
  create_stat: () => ({
    success: t`Form create successfully`,
    error: t`Unable to create form`,
  }),

  create_form_file: () => ({
    success: t`Form created successfully`,
    error: t`Unable to create form`,
  }),

  update_stat: () => ({
    success: t`Form updated successfully`,
    error: t`Unable to update form`,
  }),

  delete_stat: () => ({
    success: t`Form deleted successfully`,
    error: t`Unable to delete Form`,
  }),

  stat_form_resend_all: () => ({
    success: t`Form sent successfully`,
    error: t`Unable to send Form`,
  }),

  save_form_values: () => ({
    success: t`Form updated successfully`,
    error: t`Unable to update form`,
  }),

  unpublish_course: () => ({
    success: t`Course is Unpublished successfully`,
    error: t`Unable to unpublish course`,
  }),

  publish_course: () => ({
    success: t`Course is Published successfully`,
    error: t`Unable to publish course`,
  }),

  delete_course: () => ({
    success: t`Course deleted successfully`,
    error: t`Unable to delete course`,
  }),

  unarchive_course: () => ({
    success: t`Course is Un-archive successfully`,
    error: t`Unable to un-archive course`,
  }),

  archive_course: () => ({
    success: t`Course is Archived successfully`,
    error: t`Unable to archive course`,
  }),

  create_course: () => ({
    success: t`Course created successfully`,
    error: t`Unable to create course`,
  }),

  duplicate_course: () => ({
    success: t`Course copied successfully`,
    error: t`Unable to copied course`,
  }),

  update_course: () => ({
    success: t`Course updated successfully`,
    error: t`Unable to update course`,
  }),

  fetch_courses_error: () => t`Unable to fetch courses`,

  create_media_item: () => ({
    success: t`Media uploaded successfully`,
    error: t`Unable to upload media`,
  }),

  update_media_item: () => ({
    success: t`Media uploaded successfully`,
    error: t`Unable to upload media`,
  }),

  create_item: () => ({
    success: t`Library created successfully`,
    error: t`Unable to create library`,
  }),

  create_folder_item: () => ({
    success: t`Folder created successfully`,
    error: t`Unable to create folder`,
  }),

  create_article_item: () => ({
    success: t`Article created successfully`,
    error: t`Unable to create article`,
  }),

  create_doc_item: () => ({
    success: t`Document created successfully`,
    error: t`Unable to create document`,
  }),

  create_file_item: () => ({
    success: t`File created successfully`,
    error: t`Unable to create file`,
  }),

  create_policy_item: () => ({
    success: t`Policy created successfully`,
    error: t`Unable to create policy`,
  }),

  create_procedure_item: () => ({
    success: t`Procedure created successfully`,
    error: t`Unable to create procedure`,
  }),

  update_item: () => ({
    success: t`Library updated successfully`,
    error: t`Unable to update library`,
  }),

  update_folder_item: () => ({
    success: t`Folder updated successfully`,
    error: t`Unable to update folder`,
  }),

  update_article_item: () => ({
    success: t`Article updated successfully`,
    error: t`Unable to update article`,
  }),

  update_doc_item: () => ({
    success: t`Document updated successfully`,
    error: t`Unable to update document`,
  }),

  update_file_item: () => ({
    success: t`File updated successfully`,
    error: t`Unable to update file`,
  }),

  update_policy_item: () => ({
    success: t`Policy updated successfully`,
    error: t`Unable to update policy`,
  }),

  update_procedure_item: () => ({
    success: t`Procedure updated successfully`,
    error: t`Unable to update procedure`,
  }),

  delete_item: () => ({
    success: t`Item deleted successfully`,
    error: t`Unable to delete item`,
  }),

  delete_folder: () => ({
    success: t`Folder deleted successfully`,
    error: t`Unable to delete folder`,
  }),

  fetch_top_menu_error: () => t`Unable to fetch Menu`,

  update_top_menu: () => ({
    success: t`Menu updated successfully`,
    error: t`Unable to update Menu`,
  }),

  fetch_site_setting_error: () => t`Unable to fetch Setting`,

  update_site_setting: () => ({
    success: t`Setting updated successfully`,
    error: t`Unable to update setting`,
  }),

  // Hca Library Messages
  fetch_hca_library_error: () => t`Error occured while getting Library`,

  create_hca_volume: () => ({
    success: t`Hca Volume created successfully`,
    error: t`Unable to create Hca Volume`,
  }),

  update_hca_volume: () => ({
    success: t`Hca Volume updated successfully`,
    error: t`Unable to update Hca Volume`,
  }),

  delete_hca_volume: () => ({
    success: t`Hca Volume deleted successfully`,
    error: t`Unable to delete Hca Volume`,
  }),

  // Notes Messages
  delete_note: () => ({
    success: t`Note deleted successfully`,
    error: t`Unable to delete note`,
  }),

  create_note: () => ({
    success: t`Note created successfully`,
    error: t`Unable to create note`,
  }),

  update_note: () => ({
    success: t`Note updated successfully`,
    error: t`Unable to update note`,
  }),

  fetch_notes_error: () => t`Unable to fetch notes`,

  /* mutation - Idea*/
  create_idea: () => ({
    success: t`Idea created successfully`,
    error: t`Unable to create idea`,
  }),

  update_idea: () => ({
    success: t`Idea updated successfully`,
    error: t`Unable to update idea`,
  }),

  delete_idea: () => ({
    success: t`Idea deleted successfully`,
    error: t`Unable to delete idea`,
  }),

  /* mutation - Idea Comment*/
  create_idea_comment: () => ({
    success: t`Comment created successfully`,
    error: t`Unable to create comment`,
  }),

  update_idea_comment: () => ({
    success: t`Comment updated successfully`,
    error: t`Unable to update comment`,
  }),

  delete_idea_comment: () => ({
    success: t`Comment deleted successfully`,
    error: t`Unable to delete comment`,
  }),

  idea_vote: () => ({
    success: t`Vote saved successfully`,
    error: t`Unable to save vote`,
  }),
};
